import { useEffect, useState } from "react";
import { useFieldArray } from "react-hook-form";
const MAX_FIELDS = 7;
export const useFileFields = ({ control, anexos }) => {
    const { fields, append, update, remove, replace } = useFieldArray({
        control,
        name: "files",
    });
    const [acceptedFileTypes, setAcceptedFileTypes] = useState("image/*,video/*");
    useEffect(() => {
        const videoCount = fields.filter((f) => f.file.type.startsWith("video/")).length;
        const imageCount = fields.filter((f) => f.file.type.startsWith("image/")).length;
        const accepted = [];
        if (imageCount < 5)
            accepted.push("image/*");
        if (videoCount < 2)
            accepted.push("video/*");
        setAcceptedFileTypes(accepted.join(","));
    }, [fields]);
    useEffect(() => {
        if (!anexos?.length)
            return;
        const fetchFiles = async () => {
            const fetched = await Promise.all(anexos.map(async (anexo) => {
                if (!anexo.presignedUrl || !anexo.nomeAnexo)
                    return undefined;
                try {
                    const response = await fetch(anexo.presignedUrl);
                    if (!response.ok) {
                        throw new Error(`HTTP ${response.status}`);
                    }
                    const blob = await response.blob();
                    return {
                        id: anexo.id,
                        attachmentId: anexo.id,
                        file: new File([blob], anexo.nomeAnexo, { type: blob.type }),
                        tipo: anexo.tipo,
                        presignedUrl: anexo.presignedUrl,
                    };
                }
                catch (error) {
                    console.error(`Failed to fetch attachment ${anexo.id} (${anexo.nomeAnexo}):`, error);
                    const placeholderType = anexo.tipo === "VIDEO" ? "video/mp4" : "image/jpeg";
                    return {
                        id: anexo.id,
                        attachmentId: anexo.id,
                        file: new File([], anexo.nomeAnexo, { type: placeholderType }),
                        tipo: anexo.tipo,
                        presignedUrl: anexo.presignedUrl,
                    };
                }
            }));
            replace(fetched.filter((file) => !!file));
        };
        fetchFiles();
    }, [anexos, replace]);
    return {
        fileFields: fields,
        append,
        update,
        remove,
        acceptedFileTypes,
        MAX_FIELDS,
    };
};
